module.exports = __webpack_public_path__ + "img/icon-youtube.6c6f41bd.svg";